import { render, staticRenderFns } from "./LeadDetails.vue?vue&type=template&id=34fe2cbf&scoped=true"
import script from "./LeadDetails.vue?vue&type=script&lang=ts"
export * from "./LeadDetails.vue?vue&type=script&lang=ts"
import style0 from "./LeadDetails.vue?vue&type=style&index=0&id=34fe2cbf&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34fe2cbf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34fe2cbf')) {
      api.createRecord('34fe2cbf', component.options)
    } else {
      api.reload('34fe2cbf', component.options)
    }
    module.hot.accept("./LeadDetails.vue?vue&type=template&id=34fe2cbf&scoped=true", function () {
      api.rerender('34fe2cbf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/leads/components/LeadDetails.vue"
export default component.exports